module.exports = __webpack_public_path__ + "media/Emily.4dc79f56.mp3";